import React from "react";
import styles from "./search.module.scss";
import SearchInput from "../search-input/search-input";

// there is a small search and a big search

export default function Search(props) {
    const { searchOptions, handleFilterAndSearch, searchFilterState, searchState } = props;

    return (
        <div className={styles.search} id="science-knowledge-needs-search">
            <h2>Search opportunities</h2>
            <SearchInput
                placeholder="Search by topic, theme or keyword"
                options={searchOptions}
                handleFilterAndSearch={handleFilterAndSearch}
                searchState={searchState}
            />
            {["theme", "sub-theme", "topic", "keyword"].includes(searchFilterState.type) && (
                <div className={styles.searchAction}>Filter for {searchFilterState.type} applied below.</div>
            )}
            {searchFilterState.type === "opportunity" && (
                <div className={styles.searchAction}>Opportunity open below.</div>
            )}
        </div>
    );
}
